import React from "react";
import { useState } from "react";
import { useContext } from "react";
import { useParams } from "react-router-dom";
import { useNavigate, Link } from 'react-router-dom';


import { API_URL, MEDIA_URL, AUTH_TOKEN } from '../Context';
import ConfirmationModal from './common/ConfirmationModal';


export const STATUSES = {
  "PENDING": "Пока не доступно",
  "AVAILABLE": "Доступно для заполнения",
  "IN_PROGRESS": "Редактируется",
  "SENT": "Отправлено",
  "OUTDATED": "Просрочено",
  "RETURNED": "Возвращено",
  //"EXPORTED_TO_EAS": "Выгружено в ИАС",
  "CHECKED": "Проверено"
}

export function GetTaskStatus (status) {
  return STATUSES[status]
}


// Функция для получения иконки в зависимости от статуса
export function GetStatusIcon(status) {
  switch(status) {
    case "OUTDATED":
      return <i className="bi bi-pencil-square text-danger-emphasis" style={{fontSize: '2rem'}}></i>;  
    case "RETURNED":
      return <i className="bi bi-pencil-square text-info-emphasis" style={{fontSize: '2rem'}}></i>;
    case "SENT":
      return <i className="bi bi-clock text-warning-emphasis" style={{fontSize: '2rem'}}></i>;
    case "CHECKED":
      return <i className="bi bi-check-circle text-success" style={{fontSize: '2rem'}}></i>;                 
    default:
      return <i className="bi bi-pencil-square text-primary-emphasis" style={{fontSize: '2rem'}}></i>;
  }
}


export const STATUSES_CARD_CLASSES = {
  "OUTDATED": "bg-danger",
  "RETURNED": "bg-info",
  "AVAILABLE": "bg-primary",
  "IN_PROGRESS": "bg-primary",
  "PENDING": "bg-primary",
  "SENT": "bg-warning",
  "CHECKED": "bg-success",
}

export function GetStatusTableClass (status) {
  return STATUSES_CARD_CLASSES[status]
}


export const STATUSES_TEXT_CLASSES = {
  "OUTDATED": "text-danger-emphasis fw-semibold",
  "RETURNED": "text-info-emphasis fw-semibold",  
  "AVAILABLE": "text-primary-emphasis fw-semibold",
  "IN_PROGRESS": "text-primary-emphasis fw-semibold",
  "PENDING": "text-primary-emphasis fw-semibold",
  "SENT": "text-warning-emphasis fw-semibold",
  "CHECKED": "text-success-emphasis fw-semibold",
}

export function GetStatusTextClass (status) {
  return STATUSES_TEXT_CLASSES[status]
}

/*
export default function Task({}) {
  const [task, setTask] = useState(Object());

  const api_url = useContext(API_URL);  
  const token = useContext(AUTH_TOKEN);
  const media_url = useContext(MEDIA_URL);
  const navigate = useNavigate();

  let { taskId } = useParams();
  taskId = Number(taskId);

  React.useEffect(() => {

    let task = axios_api.get(api_url + '/manage_task/' + taskId, {
      headers: {"Authorization": token},
    });

    task.then(
      (result) => {
        let apiReturnedTask = result.data;
        setTask(apiReturnedTask);
      },
      (error) => {
        console.log(error)
        setTask([]);
      }
    );

  }, []);


  return (
    <>
      <h3 className="m-3"><Link to={`/`}>к списку заданий</Link></h3>
    </>
  )
}
*/